/** @module csi/datasheet/Splitter */
define([
	"dojo/_base/declare",
	"dojo/query",
	"csi/_base/underscore",
	"csi/html",
	"csi/printUtil",
	"csi/view/CompositeSplitter"
], function(declare,query,_,html,printUtil,CompositeSplitter) {

	/**
	 * Calculate split pane height from page height by subtracting titleblock height
	 */
	var Splitter = declare(CompositeSplitter, {
		/**
		 * Datasheet widget guarantees all page blocks are well defined, so not need to add new ones;
		 * this prevents the TitleBlock view from getting added as a page block (which means it won't repeat
		 * on each print page)
		 */
		bNewPageBlocks: false,

		/**
		 * Assign extra CSS per canvas page when splitting datasheet
		 */
		split: function(aPages, viewRoot, nPageHeight, nPageWidth, copyCallback) {
			this.inherited(arguments);

			var css = "csi-canvas-print-page";

			_.each(aPages, function(pageNode) {
				if ($(".csi-view-CanvasPage", pageNode).length) {
					$(pageNode).addClass(css);
				}
			});
		}
	});

	printUtil.registerViewSplitter("datasheet", Splitter);

	return Splitter;
});
